import { buildMenuUrl } from "../../../components/normalizeMenuUrl";

// Compare the destinations the native menu actually renders. Relative bases
// remain relative; without an origin, an absolute URL is not a proven alias.
function comparableUrl(raw, org) {
    if (typeof raw !== "string" || !raw.trim() || /^[#?]/.test(raw.trim())) return null;
    const resolved = buildMenuUrl(raw, org);
    try {
        let url;
        let kind;
        if (/^https?:\/\//i.test(resolved)) {
            url = new URL(resolved);
            kind = url.origin;
        } else if (resolved.startsWith("//")) {
            const scheme = String(org?.BASE_WEB_URL || "").match(/^https?:/i)?.[0];
            if (!scheme) return null;
            url = new URL(scheme + resolved);
            kind = url.origin;
        } else if (resolved.startsWith("/")) {
            url = new URL(resolved, "https://relative-menu.invalid");
            kind = "relative";
        } else {
            return null;
        }
        if (url.username || url.password) return null;
        return kind + (url.pathname.replace(/\/+$/, "") || "/");
    } catch {
        return null;
    }
}

/**
 * The caller passes the complete menu AFTER platform filtering and applyLang.
 * Only a rendered link with an unambiguous parent chain may replace a fallback.
 * PAGE/FORM items use their resolved public url; targetIds are never guessed.
 */
export function hasExplicitMenuRoute(menu, org, route) {
    if (!Array.isArray(menu) || menu.length === 0 || org?.limited) return false;
    const target = comparableUrl(route, org);
    if (!target) return false;

    const byId = new Map();
    const ambiguous = new Set();
    for (const item of menu) {
        if (item?.id === undefined || item.id === null || item.id === "") continue;
        if (byId.has(item.id)) ambiguous.add(item.id);
        else byId.set(item.id, item);
    }
    const accessible = (item) => {
        const visited = new Set();
        let current = item;
        while (current) {
            if (!byId.has(current.id) || ambiguous.has(current.id) || visited.has(current.id)) return false;
            visited.add(current.id);
            if (!current.parent) return true;
            current = byId.get(current.parent);
        }
        return false;
    };
    return menu.some(item => item && item.type !== "DYNAMIC_ARTICLES" &&
        comparableUrl(item.url, org) === target && accessible(item));
}

// Keep the historical strict-false flags and the same four decisions in both
// menu owners. Donation groups and other native functionality are untouched.
export function getLegacyMenuVisibility(menu, org, config = {}) {
    return {
        horaire: config["menu.horaire.active"] !== false && !hasExplicitMenuRoute(menu, org, "/horaires"),
        event: config["menu.event.active"] !== false && !hasExplicitMenuRoute(menu, org, "/evenements"),
        galerie: config["menu.galerie.active"] !== false && !hasExplicitMenuRoute(menu, org, "/galeries"),
        abo: config["menu.abo.active"] !== false && !hasExplicitMenuRoute(menu, org, "/abonnements"),
    };
}
